import { render, staticRenderFns } from "./ChapterSearch.vue?vue&type=template&id=4dc151dc&"
import script from "./ChapterSearch.vue?vue&type=script&lang=js&"
export * from "./ChapterSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports